import React, { useState, useEffect, useRef } from 'react';
// import TrustPilotWidget from "./Components/Footer/TrustPilotWidget";

const banners = [
  <div className="save-banner">
    <h2>
      Save 10% when you buy two or more items with code <span className="bold">JP10OFF</span>
    </h2>
  </div>,
  <a href="https://www.trustpilot.com/review/jigpaws.com" target="_blank" rel="noopener noreferrer"
     className="trustpilot-link">
    <div className="trustpilot-banner">

      <h2>
        See our <span className="bold">EXCELLENT</span> reviews on </h2>
      <img className="trustpilot-logo" src="/images/logos/trustpilot-logo-white.svg" alt="Trustpilot"/>
      {/*<TrustPilotWidget theme="dark" />*/}
    </div>
      </a>
    ];

    export default function GlobalBanner({interval = 3000, transitionDuration = 800}) {
    const n = banners.length;
    const slides = banners.concat(banners); // duplicate slides for seamless loop
    const containerRef = useRef(null);
    const [containerWidth, setContainerWidth] = useState(0);
    const [position, setPosition] = useState(0);
    const [isAnimating, setIsAnimating] = useState(true);

    useEffect(() => {
    function updateWidth() {
    if (containerRef.current) setContainerWidth(containerRef.current.offsetWidth);
  }
    updateWidth();
    window.addEventListener('resize', updateWidth);
    return () => window.removeEventListener('resize', updateWidth);
  }, []);

    useEffect(() => {
    const timer = setInterval(() => {
    setPosition(pos => pos + 1);
  }, interval);
    return () => clearInterval(timer);
  }, [interval]);

    // Reset position instantly when reaching the duplicate
    useEffect(() => {
    if (position === n) {
    const t = setTimeout(() => {
    setIsAnimating(false);
    setPosition(0);
    requestAnimationFrame(() => requestAnimationFrame(() => setIsAnimating(true)));
  }, transitionDuration);
    return () => clearTimeout(t);
  }
  }, [position, n, transitionDuration]);

    const sliderStyle = {
    display: 'flex',
    transform: `translateX(-${position * containerWidth}px)`,
    transition: isAnimating ? `transform ${transitionDuration}ms ease-in-out` : 'none'
  };

    const slideStyle = {
    flex: '0 0 auto',
    width: containerWidth,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    whiteSpace: 'nowrap'
  };

    return (
    <div className="accordion bgRed" style={{overflow: 'hidden'}} ref={containerRef}>
    <div className="banner-slider" style={sliderStyle}>
      {slides.map((content, i) => (
          <div key={i} className="accordionTop accordionCenter banner-slide" style={slideStyle}>
            {content}
          </div>
      ))}
    </div>
  </div>
)
;
}